/* MARCA | 24/08/2026 | New file – Variant-reactive custom element for the instalment payment options block */

import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class InstalmentOptions extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate);
  }

  handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newWidget = event.detail.data.html.querySelector('instalment-options');

    if (!newWidget) return;

    morph(this, newWidget, { childrenOnly: true });
  };
}

if (!customElements.get('instalment-options')) {
  customElements.define('instalment-options', InstalmentOptions);
}
